import _ from "underscore";
import Backbone from "backbone";
import Chaplin from "chaplin";
import MyLibrary2PageView from "views/myLibrary/MyLibrary2PageView";
import PersistentModels from "services/PersistentModels";
import RSVP from "rsvp";

const MyLibrary2PageController = Chaplin.Controller.extend({
  initialize: function (options) {
    _.extend(this, Backbone.Events);
    if (options) {
      if (options.view) {
        this.view = options.view;
      }
      if (options.model) {
        this.model = options.model;
      }
    }
  },

  getModel: function () {
    return this.model;
  },

  getView: function () {
    return this.view;
  },

  showHomePopup: function () {
    PersistentModels.getInstance().getRouter().showHomePage();
  },

  createCapsule: function () {
    PersistentModels.getInstance().getRouter().showAddAudioHightlightPageNew(
      null, null, null, null, true, true,
      null, null, null, null, null, true,
      null, null, true,
    );
  },

  buildModelAndRenderView: function () {
    return new RSVP.Promise(
      function (resolve, reject) {
        try {
          const viewParams = {};
          this.view = new MyLibrary2PageView(viewParams);

          this.listenTo(this.view, "showHomePopup", this.showHomePopup);
          this.listenTo(this.view, "createCapsule", this.createCapsule);

          this.view.render();
          resolve();
        } catch (error) {
          reject(error);
        }
      }.bind(this)
    );
  },
});

export default MyLibrary2PageController;
